import { GetterTree } from "vuex";
import { EventLinksState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<EventLinksState, RootState> = {
	getEventLinksTable: state => state.eventLinkTableResponse,
    getEventLinksList: state => state.eventLinkListResponse,
};
